import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { observer } from 'mobx-react';
import * as React from 'react';
import { hot } from 'react-hot-loader';
import { stylesheet } from "typestyle";
import * as moment from 'moment';
import CageBoxList from './CageBoxList';
import Reports from './Reports';
import OxygenLimits from './OxygenLimits';
import store from './Store';
import TimeSeriesChart from './TimeSeriesChart';
import TimeseriesChartWrapper from './TimeseriesChartWrapper';

const css = stylesheet({
  chartsRow: {
    display: 'inline-flex',
    flexDirection: 'column',
  },
  cageBoxRow: {
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  content: {
    display: 'flex',
    flex: 'auto',
    flexDirection: 'row',
  },
  flex: {
    flex: 1,
  },
  grow: {
    flexGrow: 1,
  },
  header: {
    flex: '0 0 64px',
    height: '50px',
  },
  loggers: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  map: {
    flex: 2,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
})

@observer
class App extends React.Component {

  state = {
    useNewCharts: false
  }

  public componentDidMount() {
    const viewId = window.location.hash.replace('#/', '')
    if (new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$').test(viewId)) {
      store.startView(viewId)
    }
  }

  handleChange = (_: React.ChangeEvent, value: number) => {
    store.updateTab(value)
  };

  handleChartSwitch = (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    this.setState({ useNewCharts: checked })
  }

  render() {
    const { name } = store;
    const { useNewCharts } = this.state;
    const mapLink = `/maps/#/${store.viewId}`

    const endTime = store.dailyDuration ? moment() : null
    const startTime = store.dailyDuration && endTime ? endTime.clone().subtract(moment.duration(store.dailyDuration)) : null

    return (
      <div className={css.root}>
        <AppBar className={css.header} position="static" color="default">
          <Toolbar>
            <Typography variant="title" color="inherit" className={css.flex}>
              {name}
            </Typography>

            <FormControlLabel
              control={
                <Switch
                  checked={useNewCharts}
                  onChange={this.handleChartSwitch}
                  color="primary"
                />
              }
              label={useNewCharts ? "New Charts" : "Old Charts"}
            />

            <div className={css.grow} />
            <Reports locations={store.locations} />
            <div className={css.grow} />
            <Button href={mapLink}>
              Go to maps
            </Button>
            <div className={css.grow} />
            <OxygenLimits store={store} />
          </Toolbar>
        </AppBar>
        <div className={css.content}>
          <div className={css.loggers}>
            <div className={css.cageBoxRow}>
              <CageBoxList cages={store.cages} oxygenMinimum={store.oxygenMinimum} />
            </div>
            <Tabs value={store.whichTab} onChange={this.handleChange}>
              <Tab label="Past half hour" />
              <Tab label="Past 3 hours" />
              <Tab label="Past 6 hours" />
              <Tab label="Past 12 hours" />
              <Tab label="Past 24 hours" />
              <Tab label="Past 48 hours" />
              <Tab label="Past week" />
              <Tab label="Past month" />
            </Tabs>

            <div className={css.chartsRow}>

              {useNewCharts && (
                <>
                  {store.chartData.oxygen.length > 0 && <TimeseriesChartWrapper loggers={store.loggers} data={store.chartData.oxygen} symbol="O₂" label="Oxygen" startTime={startTime} endTime={endTime} />}
                  {store.chartData.depth.length > 0 && <TimeseriesChartWrapper loggers={store.loggers} data={store.chartData.depth} symbol="m" label="Depth" startTime={startTime} endTime={endTime} />}
                </>
              )}

              {!useNewCharts && (
                <>
                  {store.chartData.oxygen.length > 0 && <TimeSeriesChart loggers={store.loggers} chartData={store.chartData} />}
                </>
              )}

              {store.chartData.ph.length > 0 && <TimeseriesChartWrapper loggers={store.loggers} data={store.chartData.ph} symbol="pH" label="pH" startTime={startTime} endTime={endTime} />}
              {store.chartData.salinity.length > 0 && <TimeseriesChartWrapper loggers={store.loggers} data={store.chartData.salinity} symbol="‰" label="Salinity in parts per thousand (‰)" startTime={startTime} endTime={endTime} />}
              {store.chartData.waterCurrent.length > 0 && <TimeseriesChartWrapper loggers={store.loggers} data={store.chartData.waterCurrent} symbol="%" label="Water current in percentage (%)" startTime={startTime} endTime={endTime} />}

            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default hot(module)(App)


// WEBPACK FOOTER //
// ./src/App.tsx